export const bnplLightRegular = {
    color_brand_font_50: 'rgba(5, 56, 64, 1)',
    color_brand_font_150: 'rgba(5, 56, 64, 1)',
    color_brand_icon_50: 'rgba(6, 113, 128, 1)',
    color_brand_border_50: 'rgba(5, 56, 64, 1)',
    color_brand_bg_50: 'rgba(6, 113, 128, 1)',
    color_brand_bg_100: 'rgba(5, 56, 64, 1)',
    color_brand_icon_100: 'rgba(5, 56, 64, 1)',
    color_comp_status_loader_primary_spinner_bg: 'rgba(5, 56, 64, 1)',
    color_comp_status_loader_primary_icon: 'rgba(5, 56, 64, 1)',
    color_contact_center_accent_default_primary_font_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_accent_default_primary_bg_50: 'rgba(103, 58, 183, 1)',
    color_contact_center_feedback_info_bg_50: 'rgba(255, 255, 255, 1)',
    color_contact_center_neutral_bg_50: 'rgba(240, 235, 248, 1)',
    color_contact_center_neutral_font_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_neutral_icon_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_neutral_border_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_accent_active_primary_border_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_neutral_bg_100: 'rgba(82, 46, 146, 1)',
    color_contact_center_accent_default_primary_icon_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_feedback_info_border_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_accent_default_secondary_border_50: 'rgba(103, 58, 183, 1)',
    color_contact_center_accent_ondefault_secondary_font_50: 'rgba(103, 58, 183, 1)',
    color_contact_center_accent_ondefault_secondary_icon_50: 'rgba(103, 58, 183, 1)',
    color_contact_center_accent_ondefault_primary_font_50: 'rgba(255, 255, 255, 1)',
    color_contact_center_accent_onhover_primary_font_50: 'rgba(255, 255, 255, 1)',
    color_contact_center_accent_onpressed_primary_font_50: 'rgba(255, 255, 255, 1)',
    color_contact_center_accent_default_secondary_bg_50: 'rgba(255, 255, 255, 1)',
    color_contact_center_accent_pressed_secondary_bg_50: 'rgba(246, 250, 251, 1)',
    color_contact_center_accent_hover_secondary_bg_50: 'rgba(246, 250, 251, 1)',
    color_contact_center_accent_ondefault_primary_icon_50: 'rgba(255, 255, 255, 1)',
    color_contact_center_accent_onhover_primary_icon_50: 'rgba(255, 255, 255, 1)',
    color_contact_center_accent_onpressed_primary_icon_50: 'rgba(255, 255, 255, 1)',
    color_contact_center_accent_hover_primary_icon_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_accent_hover_primary_font_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_accent_pressed_primary_font_50: 'rgba(52, 29, 92, 1)',
    color_contact_center_accent_pressed_primary_icon_50: 'rgba(52, 29, 92, 1)',
    color_contact_center_accent_hover_primary_bg_50: 'rgba(240, 235, 248, 1)',
    color_contact_center_accent_hover_secondary_border_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_accent_pressed_primary_bg_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_accent_pressed_secondary_border_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_feedback_error_font_50: 'rgba(159, 0, 0, 1)',
    color_contact_center_feedback_error_border_50: 'rgba(159, 0, 0, 1)',
    color_contact_center_exception_feedback_error_bg_100: 'rgba(255, 255, 255, 1)',
    color_contact_center_exception_feedback_error_bg_200: 'rgba(255, 255, 255, 1)',
    color_contact_center_feedback_error_bg_300: 'rgba(255, 234, 227, 1)',
    color_contact_center_accent_disabled_font_50: 'rgba(95, 121, 125, 1)',
    color_contact_center_accent_disabled_icon_50: 'rgba(95, 121, 125, 1)',
    color_contact_center_accent_disabled_font_100: 'rgba(187, 202, 205, 1)',
    color_contact_center_accent_disabled_icon_100: 'rgba(187, 202, 205, 1)',
    color_contact_center_accent_disabled_bg_100: 'rgba(246, 250, 251, 1)',
    color_contact_center_accent_disabled_border_100: 'rgba(187, 202, 205, 1)',
    color_contact_center_feedback_error_icon_50: 'rgba(159, 0, 0, 1)',
    color_contact_center_accent_onhover_secondary_font_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_accent_onhover_secondary_icon_50: 'rgba(82, 46, 146, 1)',
    color_contact_center_accent_onpressed_secondary_font_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_accent_onpressed_secondary_icon_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_accent_loading_secondary_bg_50: 'rgba(246, 250, 251, 1)',
    color_contact_center_accent_loading_primary_bg_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_accent_loading_secondary_border_50: 'rgba(62, 35, 110, 1)',
    color_contact_center_accent_loading_secondary_icon_50: 'rgba(62, 35, 110, 1)',
    color_secondary_icon_50: 'rgba(5, 56, 64, 1)',
    color_secondary_icon_100: 'rgba(6, 113, 128, 1)',
    radius_comp_actions_button_radiussizelarge: '1.5rem',
    radius_comp_actions_button_radiussizesmall: '1rem',
    border_comp_actions_button_bordersize: '0.0625rem',
    color_comp_actions_button_primary_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_primary_default_bg: 'rgba(122, 237, 224, 1)',
    color_comp_animation_meshgradient_bg_50: 'rgba(36, 36, 36, 1)',
    color_comp_animation_meshgradient_bg_100: 'rgba(36, 36, 36, 1)',
    color_comp_animation_meshgradient_bg_150: 'rgba(84, 102, 109, 1)',
    color_comp_animation_meshgradient_bg_200: 'rgba(84, 102, 109, 1)',
    color_comp_actions_button_primary_default_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_primary_default_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_primary_hover_icon: 'rgba(6, 113, 128, 1)',
    color_comp_actions_button_primary_hover_bg: 'rgba(196, 242, 242, 1)',
    color_comp_actions_button_primary_hover_font: 'rgba(6, 113, 128, 1)',
    color_comp_actions_button_primary_hover_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_primary_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_primary_pressed_bg: 'rgba(122, 237, 224, 1)',
    color_comp_actions_button_primary_pressed_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_primary_pressed_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_primary_loading_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_primary_loading_bg: 'rgba(122, 237, 224, 1)',
    color_comp_actions_button_secondary_default_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_secondary_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_secondary_default_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_secondary_default_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_secondary_hover_icon: 'rgba(10, 89, 101, 1)',
    color_comp_actions_button_secondary_hover_bg: 'rgba(230, 255, 255, 1)',
    color_comp_actions_button_secondary_hover_font: 'rgba(10, 89, 101, 1)',
    color_comp_actions_button_secondary_hover_border: 'rgba(10, 89, 101, 1)',
    color_comp_actions_button_secondary_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_secondary_pressed_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_secondary_pressed_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_secondary_pressed_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_secondary_loading_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_secondary_loading_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_primary_expanded_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_primaryexpanded_default_bg: 'rgba(122, 237, 224, 1)',
    color_comp_actions_button_primary_expanded_default_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_primary_expanded_default_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_primary_expanded_hover_icon: 'rgba(6, 113, 128, 1)',
    color_comp_actions_button_primary_expanded_hover_bg: 'rgba(196, 242, 242, 1)',
    color_comp_actions_button_primary_expanded_hover_font: 'rgba(6, 113, 128, 1)',
    color_comp_actions_button_primary_expanded_hover_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_primary_expanded_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_primary_expanded_pressed_bg: 'rgba(122, 237, 224, 1)',
    color_comp_actions_button_primary_expanded_pressed_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_primary_expanded_pressed_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_primary_expanded_loading_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_primary_expanded_loading_bg: 'rgba(122, 237, 224, 1)',
    color_comp_actions_button_ghost_primary_default_icon: 'rgba(6, 113, 128, 1)',
    color_comp_actions_button_ghost_primary_default_font: 'rgba(6, 113, 128, 1)',
    color_comp_actions_button_ghost_primary_default_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_ghost_primary_hover_icon: 'rgba(196, 242, 242, 1)',
    color_comp_actions_button_ghost_primary_hover_font: 'rgba(196, 242, 242, 1)',
    color_comp_actions_button_ghost_primary_hover_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_ghost_primary_pressed_icon: 'rgba(6, 113, 128, 1)',
    color_comp_actions_button_ghost_primary_pressed_font: 'rgba(6, 113, 128, 1)',
    color_comp_actions_button_ghost_primary_pressed_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_ghost_secondary_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_ghost_secondary_default_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_ghost_secondary_default_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_ghost_secondary_hover_icon: 'rgba(145, 170, 173, 1)',
    color_comp_actions_button_ghost_secondary_hover_font: 'rgba(145, 170, 173, 1)',
    color_comp_actions_button_ghost_secondary_hover_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_button_ghost_secondary_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_ghost_secondary_pressed_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_button_ghost_secondary_pressed_bgcolor: 'rgba(255, 255, 255, 0)',
    radius_comp_actions_buttontechonly_radiussizelarge: '1.5rem',
    radius_comp_actions_buttontechonly_radiussizesmall: '1rem',
    border_comp_actions_buttontechonly_bordersize: '0.0625rem',
    color_comp_actions_buttontechonly_secondaryonsurface_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_buttontechonly_secondaryonsurface_default_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_buttontechonly_secondaryonsurface_default_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_buttontechonly_secondaryonsurface_default_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_buttontechonly_secondaryonsurface_hover_icon: 'rgba(10, 89, 101, 1)',
    color_comp_actions_buttontechonly_secondaryonsurface_hover_bg: 'rgba(230, 255, 255, 1)',
    color_comp_actions_buttontechonly_secondaryonsurface_hover_font: 'rgba(10, 89, 101, 1)',
    color_comp_actions_buttontechonly_secondaryonsurface_hover_border: 'rgba(10, 89, 101, 1)',
    color_comp_actions_buttontechonly_secondaryonsurface_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_buttontechonly_secondaryonsurface_pressed_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_buttontechonly_secondaryonsurface_pressed_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_buttontechonly_secondaryonsurface_pressed_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_buttontechonly_secondaryonsurface_loading_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_buttontechonly_secondaryonsurface_loading_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_buttontechonly_ghostsecondaryonsurface_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_buttontechonly_ghostsecondaryonsurface_default_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_buttontechonly_ghostsecondaryonsurface_default_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_buttontechonly_ghostsecondaryonsurface_hover_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_buttontechonly_ghostsecondaryonsurface_hover_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_buttontechonly_ghostsecondaryonsurface_hover_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_buttontechonly_ghostsecondaryonsurface_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_buttontechonly_ghostsecondaryonsurface_pressed_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_buttontechonly_ghostsecondaryonsurface_pressed_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_closebutton_primary_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_closebutton_secondary_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_closebutton_secondary_default_bg: 'rgba(255, 255, 255, 1)',
    color_comp_actions_closebuttontechonly_primaryonsurfaceblack_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_closebuttontechonly_primaryonsurfacewhite_default_icon: 'rgba(255, 255, 255, 1)',
    color_comp_actions_closebuttontechonly_secondaryonsurface_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_closebuttontechonly_secondaryonsurface_default_bg: 'rgba(255, 255, 255, 1)',
    color_comp_actions_closebuttontechonly_custom_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbutton_primary_default_icon: 'rgba(6, 113, 128, 1)',
    color_comp_actions_iconbutton_primary_hover_icon: 'rgba(6, 113, 128, 1)',
    color_comp_actions_iconbutton_primary_pressed_icon: 'rgba(6, 113, 128, 1)',
    color_comp_actions_iconbutton_secondary_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_feedback_badgenotifications_secondary_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbutton_secondary_hover_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbutton_secondary_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbutton_tertiary_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbutton_tertiary_hover_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbutton_tertiary_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbutton_inverse_default_icon: 'rgba(255, 255, 255, 1)',
    color_comp_actions_iconbutton_inverse_hover_icon: 'rgba(255, 255, 255, 1)',
    color_comp_actions_iconbutton_inverse_pressed_icon: 'rgba(255, 255, 255, 1)',
    color_comp_actions_iconbutton_primaryfilled_default_icon: 'rgba(255, 255, 255, 1)',
    color_comp_actions_iconbutton_primaryfilled_default_bg: 'rgba(10, 89, 101, 1)',
    color_comp_actions_iconbutton_primaryfilled_hover_icon: 'rgba(255, 255, 255, 1)',
    color_comp_actions_iconbutton_primaryfilled_hover_bg: 'rgba(31, 127, 141, 1)',
    color_comp_actions_iconbutton_primaryfilled_pressed_icon: 'rgba(255, 255, 255, 1)',
    color_comp_actions_iconbutton_primaryfilled_pressed_bg: 'rgba(10, 89, 101, 1)',
    color_comp_actions_iconbutton_secondaryfilled_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbutton_secondaryfilled_default_bg: 'rgba(255, 255, 255, 1)',
    color_comp_actions_iconbutton_secondaryfilled_default_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbutton_secondaryfilled_hover_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbutton_secondaryfilled_hover_bg: 'rgba(230, 255, 255, 1)',
    color_comp_actions_iconbutton_secondaryfilled_hover_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbutton_secondaryfilled_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbutton_secondaryfilled_pressed_bg: 'rgba(255, 255, 255, 1)',
    color_comp_actions_iconbutton_secondaryfilled_pressed_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbuttontechonlyonsurface_primary_default_icon: 'rgba(6, 113, 128, 1)',
    color_comp_actions_iconbuttontechonlyonsurface_primary_hover_icon: 'rgba(6, 113, 128, 1)',
    color_comp_actions_iconbuttontechonlyonsurface_primary_pressed_icon: 'rgba(10, 89, 101, 1)',
    color_comp_actions_iconbuttontechonlyonsurface_secondary_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbuttontechonlyonsurface_secondary_hover_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbuttontechonlyonsurface_secondary_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_tabfab_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_tabfab_bg: 'rgba(255, 255, 255, 1)',
    border_comp_actions_quickbutton_bordersize: '0.0625rem',
    radius_comp_actions_quickbutton_radiussize: '22.5rem',
    color_comp_actions_quickbutton_primary_default_label: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_primary_default_icon: 'rgba(255, 255, 255, 1)',
    color_comp_actions_quickbutton_primary_default_bg: 'rgba(6, 113, 128, 1)',
    color_comp_actions_quickbutton_primary_default_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_quickbutton_primary_default_initials: 'rgba(255, 255, 255, 1)',
    color_comp_actions_quickbutton_primary_pressed_label: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_primary_pressed_icon: 'rgba(255, 255, 255, 1)',
    color_comp_actions_quickbutton_primary_pressed_bg: 'rgba(6, 113, 128, 1)',
    color_comp_actions_quickbutton_primary_pressed_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_quickbutton_primary_pressed_initials: 'rgba(255, 255, 255, 1)',
    color_comp_actions_quickbutton_secondary_default_label: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_secondary_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_secondary_default_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_quickbutton_secondary_default_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_secondary_pressed_label: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_secondary_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_secondary_pressed_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_quickbutton_secondary_pressed_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_tertiary_default_label: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_tertiary_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_tertiary_default_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_quickbutton_tertiary_default_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_tertiary_pressed_label: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_tertiary_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_tertiary_pressed_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_quickbutton_tertiary_pressed_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_on_page_primary_default_icon: 'rgba(255, 255, 255, 1)',
    color_comp_actions_quickbutton_on_page_primary_default_bg: 'rgba(6, 113, 128, 1)',
    color_comp_actions_quickbutton_on_page_primary_default_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_quickbutton_on_page_primary_default_initials: 'rgba(255, 255, 255, 1)',
    color_comp_actions_quickbutton_on_page_primary_default_label: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_on_page_primary_pressed_icon: 'rgba(255, 255, 255, 1)',
    color_comp_actions_quickbutton_on_page_primary_pressed_bg: 'rgba(6, 113, 128, 1)',
    color_comp_actions_quickbutton_on_page_primary_pressed_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_quickbutton_on_page_primary_pressed_initials: 'rgba(255, 255, 255, 1)',
    color_comp_actions_quickbutton_on_page_primary_pressed_label: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_on_page_secondary_default_label: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_on_page_secondary_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_on_page_secondary_default_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_quickbutton_on_page_secondary_default_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_on_page_secondary_pressed_label: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_on_page_secondary_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_on_page_secondary_pressed_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_quickbutton_on_page_secondary_pressed_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_on_page_tertiary_default_label: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_on_page_tertiary_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_on_page_tertiary_default_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_quickbutton_on_page_tertiary_default_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_on_page_tertiary_pressed_label: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_on_page_tertiary_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_on_page_tertiary_pressed_bg: 'rgba(255, 255, 255, 0)',
    color_comp_actions_quickbutton_on_page_tertiary_pressed_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_image_default_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_image_default_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_image_pressed_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_quickbutton_image_pressed_border: 'rgba(5, 56, 64, 1)',
    color_comp_actions_floatingbutton_icon: 'rgba(255, 255, 255, 1)',
    color_comp_actions_floatingbuttonextended_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_floatingbuttonextended_default_bg: 'rgba(122, 237, 224, 1)',
    color_comp_actions_floatingbuttonextended_default_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_floatingbuttonextended_default_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_floatingbuttonextended_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_floatingbuttonextended_pressed_bg: 'rgba(122, 237, 224, 1)',
    color_comp_actions_floatingbuttonextended_pressed_font: 'rgba(5, 56, 64, 1)',
    color_comp_actions_floatingbuttonextended_pressed_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_floatingbuttonextended_loading_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_floatingbuttonextended_loading_bg: 'rgba(221, 229, 231, 1)',
    color_comp_actions_floatingbutton_bg: 'rgba(5, 56, 64, 1)',
    color_comp_actions_floatingbutton_border: 'rgba(255, 255, 255, 0)',
    color_comp_navigation_navigationrow_lefticon_icon: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_navigationcard_lefticon_icon: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_navigationrow_righticon_icon: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_navigationcard_righticon_icon: 'rgba(5, 56, 64, 1)',
    color_secondary_icon_150: 'rgba(5, 56, 64, 1)',
    color_comp_assistedchanels_taskalert_border: 'rgba(5, 56, 64, 1)',
    radius_comp_commercial_commercialcard_containerradius: '1.5rem',
    radius_comp_forms_selectorcardcontent_radiussize: '1rem',
    radius_comp_commercial_commercialcard_image_radiussize: '1.25rem',
    radius_comp_containers_accordionsection_radiussize: '1.5rem',
    radius_comp_assistedchanels_selectorcardoperative_radiussize: '1rem',
    color_comp_content_insight_icon: 'rgba(5, 56, 64, 1)',
    color_comp_containers_bg: 'rgba(255, 255, 255, 1)',
    color_comp_datavisualization_linechart_areachart_positiveline_border: 'rgba(31, 127, 141, 1)',
    color_comp_datavisualization_linechart_areachart_negativeline_border: 'rgba(135, 18, 57, 1)',
    color_comp_datavisualization_charlegend_font: 'rgba(5, 56, 64, 1)',
    color_comp_containers_drawer_topline_bg: 'rgba(122, 237, 224, 1)',
    size_comp_containers_drawer_size_desktop_large: '45.75rem',
    size_comp_containers_drawer_size_tablet_large: '36.375rem',
    size_comp_containers_drawer_size_tablet_medium: '24.75rem',
    size_comp_containers_drawer_size_desktop_medium: '31rem',
    radius_comp_containers_modal_topradius_radiussize: '1.5rem',
    radius_comp_containers_modal_desktopradius_radiussize: '1.5rem',
    radius_comp_containers_contextmenu_radiussize: '1.5rem',
    size_comp_containers_modal_illustration_size: '7.5rem',
    radius_comp_container_tooltip_desktop_radiussize: '1.5rem',
    comp_containers_tooltip_desktop_radiussize: '1.5rem',
    color_comp_containers_tooltip_desktop_bg: 'rgba(221, 250, 252, 1)',
    color_comp_containers_tooltip_desktop_border: 'rgba(5, 56, 64, 1)',
    color_comp_containers_highlighted_bg: 'rgba(246, 250, 251, 1)',
    radius_comp_containers_bubble_containerradius: '0.75rem',
    color_comp_containers_bubble_user_bg: 'rgba(230, 255, 255, 1)',
    color_comp_containers_bubble_agent_bg: 'rgba(234, 236, 255, 1)',
    color_comp_containers_bubble_agent_title_font: 'rgba(10, 89, 101, 1)',
    color_comp_containers_bubble_chatbot_bg: 'rgba(234, 236, 255, 1)',
    color_comp_containers_bubble_chatbot_title_font: 'rgba(10, 89, 101, 1)',
    color_comp_containers_accordionsection_border: 'rgba(36, 36, 36, 1)',
    color_comp_containers_draggablecontainer_border: 'rgba(221, 229, 231, 1)',
    radius_comp_containers_draggablecontainer_radiussize: '1rem',
    color_comp_containers_draggablecontainer_icon: 'rgba(36, 36, 36, 1)',
    color_comp_containers_draggablecontainer_unselected_header_bg: 'rgba(246, 250, 251, 1)',
    color_comp_containers_draggablecontainer_selected_header_bg: 'rgba(246, 250, 251, 1)',
    color_comp_containers_accordion_font: 'rgba(5, 56, 64, 1)',
    color_comp_containers_accordion_icon: 'rgba(5, 56, 64, 1)',
    color_comp_containers_accordion_standard_bg: 'rgba(255, 255, 255, 1)',
    color_comp_containers_accordion_neutral_bg: 'rgba(246, 250, 251, 1)',
    color_secondary_icon_200: 'rgba(5, 56, 64, 1)',
    color_secondary_icon_350: 'rgba(5, 56, 64, 1)',
    color_secondary_icon_400: 'rgba(5, 56, 64, 1)',
    color_secondary_icon_450: 'rgba(5, 56, 64, 1)',
    color_secondary_border_50: 'rgba(5, 56, 64, 1)',
    color_secondary_border_100: 'rgba(5, 56, 64, 1)',
    color_secondary_border_mainsection_100: 'rgba(5, 56, 64, 1)',
    color_secondary_border_200: 'rgba(5, 56, 64, 1)',
    color_secondary_bg_50: 'rgba(204, 26, 26, 1)',
    color_secondary_bg_100: 'rgba(5, 56, 64, 1)',
    color_secondary_bg_150: 'rgba(221, 250, 252, 1)',
    color_secondary_bg_200: 'rgba(5, 56, 64, 1)',
    color_secondary_bg_250: 'rgba(5, 56, 64, 1)',
    color_secondary_bg_400: 'rgba(5, 56, 64, 1)',
    color_secondary_bg_450: 'rgba(5, 56, 64, 1)',
    color_secondary_bg_475: 'rgba(5, 56, 64, 1)',
    color_secondary_bg_500: 'rgba(221, 250, 252, 1)',
    color_neutral_border_static_50: 'rgba(255, 255, 255, 1)',
    color_comp_feedback_badgenotifications_icon: 'rgba(5, 56, 64, 1)',
    color_comp_forms_calendar_selected_font: 'rgba(255, 255, 255, 1)',
    color_comp_forms_calendar_selected_bg: 'rgba(5, 56, 64, 1)',
    color_comp_forms_calendar_current_border: 'rgba(5, 56, 64, 1)',
    color_comp_forms_calendar_range_bg: 'rgba(5, 56, 64, 0.14901960784313725)',
    color_comp_forms_calendar_native_selected_bg: 'rgba(5, 56, 64, 0.09803921568627451)',
    color_comp_forms_calendar_native_selected_font: 'rgba(6, 113, 128, 1)',
    color_comp_forms_calendar_native_current_font: 'rgba(6, 113, 128, 1)',
    color_comp_forms_calendar_native_actions_default_icon: 'rgba(6, 113, 128, 1)',
    color_comp_forms_calendar_ios_accent: 'rgba(6, 113, 128, 1)',
    color_comp_forms_filemanager_bg: 'rgba(255, 255, 255, 1)',
    color_comp_forms_filemanager_border: 'rgba(187, 202, 205, 1)',
    color_comp_forms_filemanager_icon: 'rgba(5, 56, 64, 1)',
    radius_comp_forms_filemanager_radiussize: '1rem',
    radius_comp_forms_selectorrow_custom_radiussize: '1rem',
    color_comp_forms_filemanager_loadingcontainer_border: 'rgba(10, 111, 101, 1)',
    color_comp_forms_selectorrow_custom_icon: 'rgba(5, 56, 64, 1)',
    color_comp_forms_select_icon: 'rgba(5, 56, 64, 1)',
    color_comp_forms_select_bg: 'rgba(255, 255, 255, 1)',
    color_comp_forms_select_neutral_bg: 'rgba(246, 250, 251, 1)',
    color_comp_forms_select_filled_font: 'rgba(5, 56, 64, 1)',
    color_comp_forms_select_default_font: 'rgba(84, 102, 109, 1)',
    color_comp_forms_selectorcardcontent_blocked_bg: 'rgba(255, 255, 255, 1)',
    radius_comp_forms_checkbox_radiussize: '0.25rem',
    color_comp_forms_checkbox_unselected_bg: 'rgba(255, 255, 255, 0)',
    color_comp_forms_checkbox_selected_bg: 'rgba(255, 255, 255, 0)',
    color_comp_forms_chip_bg: 'rgba(246, 250, 251, 1)',
    color_comp_forms_chip_border: 'rgba(5, 56, 64, 1)',
    radius_comp_forms_chip_radiussize: '1rem',
    radius_comp_navigation_navigationrow_radiussize: '1rem',
    color_comp_forms_draggableitem_draggable_bg: 'rgba(255, 255, 255, 1)',
    color_comp_forms_draggableitem_draggable_icon: 'rgba(5, 56, 64, 1)',
    radius_comp_forms_toggle_thumbradiussize: '22.5rem',
    radius_comp_forms_toggle_radiussize: '22.5rem',
    color_comp_forms_toggle_selected_bg: 'rgba(122, 237, 224, 1)',
    color_comp_forms_toggle_selected_border: 'rgba(5, 56, 64, 1)',
    color_comp_forms_switchcard_border: 'rgba(255, 255, 255, 0)',
    color_comp_forms_toggle_selected_icon: 'rgba(5, 56, 64, 1)',
    color_comp_forms_toggle_selected_thumb_bg: 'rgba(255, 255, 255, 1)',
    color_comp_forms_toggle_unselected_bg: 'rgba(5, 56, 64, 1)',
    color_comp_forms_toggle_unselected_thumb_bg: 'rgba(255, 255, 255, 1)',
    radius_comp_forms_pill_radiussize: '22.5rem',
    color_comp_forms_pill_unselected_bg: 'rgba(255, 255, 255, 1)',
    color_comp_forms_pill_unselected_border: 'rgba(5, 56, 64, 1)',
    color_comp_forms_pill_unselected_icon: 'rgba(5, 56, 64, 1)',
    color_comp_forms_pill_unselected_font: 'rgba(5, 56, 64, 1)',
    color_comp_forms_pill_selected_bg: 'rgba(122, 237, 224, 1)',
    color_comp_forms_pill_selected_border: 'rgba(5, 56, 64, 1)',
    color_comp_forms_pill_selected_icon: 'rgba(5, 56, 64, 1)',
    color_accent_selected_onselected_font_50: 'rgba(5, 56, 64, 1)',
    radius_comp_forms_radiobutton_radiussize: '22.5rem',
    color_comp_forms_radiobutton_unselected_bg: 'rgba(255, 255, 255, 0)',
    color_comp_forms_radiobutton_selected_bg: 'rgba(255, 255, 255, 0)',
    radius_comp_forms_segmentedcontrol_radiussize: '22.5rem',
    color_comp_forms_segmentedcontrol_bg: 'rgba(255, 255, 255, 1)',
    color_comp_forms_segmentedcontrol_border: 'rgba(5, 56, 64, 1)',
    radius_comp_forms_segmentedcontrol_option_radiussize: '22.5rem',
    color_comp_forms_segmentedcontrol_option_unselected_bg: 'rgba(255, 255, 255, 1)',
    color_comp_forms_segmentedcontrol_option_unselected_font: 'rgba(5, 56, 64, 1)',
    color_comp_forms_segmentedcontrol_option_selected_bg: 'rgba(122, 237, 224, 1)',
    color_comp_forms_segmentedcontrol_option_selected_font: 'rgba(5, 56, 64, 1)',
    color_comp_forms_selectorrowagenda_selected_bg: 'rgba(230, 255, 255, 1)',
    color_comp_forms_slider_bar_bg: 'rgba(5, 56, 64, 1)',
    color_comp_forms_slider_handle_bg: 'rgba(255, 255, 255, 1)',
    color_comp_forms_slider_handle_border: 'rgba(5, 56, 64, 1)',
    color_comp_forms_slider_handle_icon: 'rgba(95, 121, 125, 1)',
    radius_comp_forms_input_radiussize: '1rem',
    color_comp_forms_input_bg: 'rgba(255, 255, 255, 1)',
    color_comp_forms_input_bgprefixsufix: 'rgba(221, 229, 231, 1)',
    color_comp_forms_input_secondaryfont: 'rgba(95, 121, 125, 1)',
    color_comp_forms_input_icon: 'rgba(5, 56, 64, 1)',
    color_comp_forms_input_error_empty_bg: 'rgba(255, 255, 255, 1)',
    color_comp_forms_input_error_filled_bg: 'rgba(255, 255, 255, 1)',
    color_comp_forms_input_active_border: 'rgba(5, 56, 64, 1)',
    color_comp_forms_input_empty_font: 'rgba(95, 121, 125, 1)',
    color_comp_forms_input_filled_font: 'rgba(5, 56, 64, 1)',
    color_comp_forms_input_filled_border: 'rgba(5, 56, 64, 1)',
    radius_comp_forms_inputcurrencylarge_radiussize: '1rem',
    radius_comp_forms_inputsignature_radiussize: '1rem',
    radius_comp_forms_inputdigitsequence_radiussize: '1rem',
    color_comp_feedback_rating_shape_selected_bg: 'rgba(5, 56, 64, 1)',
    color_comp_feedback_rating_shape_hover_bg: 'rgba(5, 56, 64, 1)',
    color_comp_feedback_rating_shape_unselected_bg: 'rgba(95, 121, 125, 1)',
    radius_comp_feedback_calloutalert_radiussize: '1rem',
    border_comp_feedback_calloutalert_bordersize: '0.0625rem',
    color_comp_feedback_calloutalert_iconillustrationimage_bg: 'rgba(246, 250, 251, 1)',
    color_comp_feedback_calloutalert_iconillustrationimage_border: 'rgba(10, 89, 101, 1)',
    color_comp_feedback_calloutalert_conversational_bg: 'rgba(255, 255, 255, 1)',
    color_comp_feedback_calloutalert_conversational_border: 'rgba(255, 255, 255, 0)',
    radius_comp_feedback_message_borderradius: '1rem',
    border_comp_feedback_message_bordersize: '0.125rem',
    color_comp_feedback_message_info_bg: 'rgba(255, 255, 255, 1)',
    color_comp_feedback_message_info_border: 'rgba(10, 89, 101, 1)',
    color_comp_feedback_message_warning_bg: 'rgba(255, 255, 255, 1)',
    color_comp_feedback_message_warning_border: 'rgba(206, 112, 24, 1)',
    color_comp_feedback_message_success_bg: 'rgba(255, 255, 255, 1)',
    color_comp_feedback_message_success_border: 'rgba(18, 135, 43, 1)',
    color_comp_feedback_message_error_bg: 'rgba(255, 255, 255, 1)',
    color_comp_feedback_message_error_border: 'rgba(159, 0, 0, 1)',
    radius_comp_feedback_snackbar_radiussize: '1rem',
    border_comp_feedback_snackbar_bordersize: '0.125rem',
    color_comp_feedback_snackbar_info_bg: 'rgba(221, 250, 252, 1)',
    color_comp_feedback_snackbar_info_border: 'rgba(10, 89, 101, 1)',
    color_comp_feedback_snackbar_warning_bg: 'rgba(255, 238, 221, 1)',
    color_comp_feedback_snackbar_warning_border: 'rgba(206, 112, 24, 1)',
    color_comp_feedback_snackbar_success_bg: 'rgba(236, 255, 240, 1)',
    color_comp_feedback_snackbar_success_border: 'rgba(18, 135, 43, 1)',
    color_comp_feedback_snackbar_error_bg: 'rgba(255, 234, 227, 1)',
    color_comp_feedback_snackbar_error_border: 'rgba(159, 0, 0, 1)',
    color_comp_resources_badgeicon_border: 'rgba(255, 255, 255, 1)',
    color_neutral_font_50: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_primarytabs_font: 'rgba(5, 56, 64, 1)',
    color_comp_resources_avatarprofile_selector_initials_font: 'rgba(5, 56, 64, 1)',
    color_comp_resources_avatarprofile_selector_icon_icon: 'rgba(5, 56, 64, 1)',
    color_neutral_font_100: 'rgba(84, 102, 109, 1)',
    color_neutral_font_250: 'rgba(255, 255, 255, 1)',
    color_neutral_font_300: 'rgba(5, 56, 64, 1)',
    color_neutral_font_static_white: 'rgba(255, 255, 255, 1)',
    color_comp_legal_risklevelbar_container_default_bg: 'rgba(246, 250, 251, 1)',
    color_comp_legal_risklevelbar_number_default_font: 'rgba(89, 111, 115, 1)',
    radius_comp_navigation_navbar_radiussize: '0rem',
    color_comp_content_notifications_swipe_op1_bg: 'rgba(36, 36, 36, 1)',
    color_comp_content_notifications_swipe_op2_bg: 'rgba(204, 26, 26, 1)',
    radius_comp_content_informativecard_radiussize: '1rem',
    radius_comp_forms_switchcard_radiussize: '1rem',
    radius_comp_forms_selectorcardexpander_radiussize: '1rem',
    radius_comp_forms_calendar_radiussize: '1.5rem',
    color_comp_content_docreader_bg: 'rgba(246, 250, 251, 1)',
    color_comp_actions_feedbackbutton_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_actions_feedbackbutton_default_border: 'rgba(255, 255, 255, 0)',
    color_comp_actions_feedbackbutton_default_bg: 'rgba(255, 255, 255, 1)',
    radius_comp_content_productcard_radiussize: '1rem',
    color_neutral_icon_50: 'rgba(5, 56, 64, 1)',
    color_comp_content_informativerow_icon: 'rgba(5, 56, 64, 1)',
    color_comp_resources_avatarprofile_empty_default_icon: 'rgba(5, 56, 64, 1)',
    color_neutral_icon_mainsection_50: 'rgba(5, 56, 64, 1)',
    color_neutral_icon_150: 'rgba(95, 121, 125, 1)',
    color_neutral_icon_200: 'rgba(255, 255, 255, 1)',
    color_neutral_border_125: 'rgba(5, 56, 64, 1)',
    color_neutral_icon_static_white: 'rgba(255, 255, 255, 1)',
    color_neutral_border_150: 'rgba(5, 56, 64, 1)',
    color_comp_resources_avatarprofile_selector_border: 'rgba(5, 56, 64, 1)',
    color_neutral_border_mainsection_50: 'rgba(5, 56, 64, 1)',
    color_neutral_border_160: 'rgba(187, 202, 205, 1)',
    color_neutral_bg_375: 'rgba(255, 255, 255, 1)',
    color_comp_status_progressbar_embedded_empty_bg: 'rgba(127, 153, 159, 1)',
    color_comp_status_tag_neutral_border: 'rgba(95, 121, 125, 1)',
    color_comp_status_tag_neutral_font: 'rgba(5, 56, 64, 1)',
    color_comp_status_tag_neutral_icon: 'rgba(5, 56, 64, 1)',
    color_comp_tag_neutral_bg: 'rgba(221, 229, 231, 1)',
    color_comp_status_tag_newness_bg: 'rgba(122, 133, 237, 1)',
    color_comp_status_tag_newness_icon: 'rgba(36, 36, 36, 1)',
    color_comp_status_tag_newness_font: 'rgba(36, 36, 36, 1)',
    color_comp_status_tag_primarynofeedback_bg: 'rgba(5, 56, 64, 1)',
    color_comp_status_tag_primarynofeedback_font: 'rgba(255, 255, 255, 1)',
    color_comp_status_tag_primarynofeedback_icon: 'rgba(255, 255, 255, 1)',
    color_comp_status_tag_primarynofeedback_border: 'rgba(255, 255, 255, 0)',
    color_comp_status_tag_secondarynofeedback_bg: 'rgba(95, 121, 125, 1)',
    color_comp_status_tag_secondarynofeedback_font: 'rgba(255, 255, 255, 1)',
    color_comp_status_tag_secondarynofeedback_icon: 'rgba(255, 255, 255, 1)',
    color_comp_status_tag_secondarynofeedback_border: 'rgba(255, 255, 255, 0)',
    color_comp_status_tag_feedback_icon: 'rgba(5, 56, 64, 1)',
    color_comp_status_tag_feedback_info_border: 'rgba(10, 89, 101, 1)',
    color_comp_status_tag_feedback_info_font: 'rgba(5, 56, 64, 1)',
    color_comp_status_tag_feedback_warning_border: 'rgba(206, 112, 24, 1)',
    color_comp_status_tag_feedback_warning_font: 'rgba(5, 56, 64, 1)',
    color_comp_status_tag_feedback_success_border: 'rgba(18, 135, 43, 1)',
    color_comp_status_tag_feedback_success_font: 'rgba(5, 56, 64, 1)',
    color_comp_status_tag_feedback_error_border: 'rgba(159, 0, 0, 1)',
    color_comp_status_tag_feedback_error_font: 'rgba(5, 56, 64, 1)',
    color_comp_status_tag_dandernofeedback_border: 'rgba(255, 255, 255, 0)',
    color_comp_status_tag_disabled_border: 'rgba(145, 170, 173, 1)',
    color_comp_status_tag_disabled_font: 'rgba(84, 102, 109, 1)',
    color_comp_status_tag_disabled_icon: 'rgba(84, 102, 109, 1)',
    color_comp_status_tag_disabled_bg: 'rgba(221, 229, 231, 1)',
    radius_comp_status_tag_radiussize: '0.5rem',
    color_neutral_bg_300: 'rgba(246, 250, 251, 1)',
    color_comp_resources_badgeicon_default_bg: 'rgba(246, 250, 251, 1)',
    color_comp_resources_badgelogo_empty_bg: 'rgba(246, 250, 251, 1)',
    color_comp_resources_iconhighlighted_circle_default_bg: 'rgba(246, 250, 251, 1)',
    color_comp_forms_switchcard_regular_bg: 'rgba(246, 250, 251, 1)',
    color_comp_assistedchanels_taskalert_bg: 'rgba(246, 250, 251, 1)',
    color_neutral_bg_50: 'rgba(5, 56, 64, 1)',
    color_comp_status_progressbar_embedded_filled_bg: 'rgba(5, 56, 64, 1)',
    color_neutral_bg_static_100: 'rgba(255, 255, 255, 1)',
    color_comp_status_tag_dandernofeedback_bg: 'rgba(159, 0, 0, 1)',
    color_comp_navigation_navigationstatuscard_neutral_bg: 'rgba(255, 255, 255, 1)',
    color_comp_content_informativecard_neutral_info_bg: 'rgba(255, 255, 255, 1)',
    color_comp_content_informativecard_neutral_success_bg: 'rgba(255, 255, 255, 1)',
    color_neutral_bg_static_75: 'rgba(187, 202, 205, 1)',
    color_neutral_bg_static_50: 'rgba(36, 36, 36, 1)',
    color_comp_legal_risklevelbar_container_border: 'rgba(0, 0, 0, 1)',
    color_neutral_bg_opacity_overlay: 'rgba(5, 56, 64, 0.8)',
    color_neutral_bg_opacity_50: 'rgba(255, 255, 255, 0.4980392156862745)',
    color_neutral_bg_opacity_00: 'rgba(255, 255, 255, 0)',
    color_comp_resources_avatarprofile_empty_default_bg: 'rgba(255, 255, 255, 0)',
    color_neutral_screen_bg_50: 'rgba(191, 236, 239, 1)',
    color_neutral_screen_bg_175: 'rgba(255, 255, 255, 1)',
    color_neutral_screen_bg_150: 'rgba(246, 250, 251, 1)',
    color_comp_navigation_browsertabs_bg: 'rgba(246, 250, 251, 1)',
    color_neutral_screen_bg_450: 'rgba(246, 250, 251, 1)',
    color_neutral_screen_bg_475: 'rgba(221, 250, 252, 1)',
    color_neutral_bg_mainsection_50: 'rgba(255, 255, 255, 1)',
    color_neutral_font_mainsection_50: 'rgba(95, 121, 125, 1)',
    color_neutral_font_onsurface_50: 'rgba(5, 56, 64, 1)',
    color_neutral_border_mainsection_100: 'rgba(5, 56, 64, 1)',
    color_neutral_screen_bg_wealth_50: 'rgba(255, 255, 255, 0)',
    color_feedback_info_font_50: 'rgba(10, 89, 101, 1)',
    color_feedback_info_icon_50: 'rgba(10, 89, 101, 1)',
    color_feedback_info_border_50: 'rgba(10, 89, 101, 1)',
    color_feedback_info_border_100: 'rgba(10, 89, 101, 1)',
    color_feedback_info_border_150: 'rgba(10, 89, 101, 1)',
    color_feedback_info_bg_50: 'rgba(6, 113, 128, 1)',
    color_feedback_info_bg_100: 'rgba(10, 89, 101, 1)',
    color_feedback_info_bg_150: 'rgba(221, 250, 252, 1)',
    color_comp_content_informativecard_regular_bg: 'rgba(221, 250, 252, 1)',
    color_feedback_warning_font_50: 'rgba(206, 112, 24, 1)',
    color_feedback_warning_icon_50: 'rgba(206, 112, 24, 1)',
    color_feedback_warning_border_50: 'rgba(206, 112, 24, 1)',
    color_feedback_warning_border_100: 'rgba(206, 112, 24, 1)',
    color_feedback_warning_bg_50: 'rgba(242, 161, 84, 1)',
    color_feedback_warning_bg_100: 'rgba(206, 112, 24, 1)',
    color_feedback_warning_bg_150: 'rgba(255, 238, 221, 1)',
    color_feedback_success_font_50: 'rgba(18, 135, 43, 1)',
    color_feedback_success_font_425: 'rgba(76, 192, 101, 1)',
    color_feedback_success_icon_50: 'rgba(18, 135, 43, 1)',
    color_comp_actions_feedbackbutton_positive_icon: 'rgba(18, 135, 43, 1)',
    color_feedback_success_icon_75: 'rgba(18, 135, 43, 1)',
    color_feedback_success_border_50: 'rgba(18, 135, 43, 1)',
    color_comp_actions_feedbackbutton_positive_border: 'rgba(18, 135, 43, 1)',
    color_feedback_success_border_100: 'rgba(18, 135, 43, 1)',
    color_feedback_success_bg_50: 'rgba(76, 192, 101, 1)',
    color_feedback_status_bg_50: 'rgba(122, 133, 237, 1)',
    color_feedback_success_bg_100: 'rgba(18, 135, 43, 1)',
    color_feedback_success_bg_150: 'rgba(236, 255, 240, 1)',
    color_comp_actions_feedbackbutton_positive_bg: 'rgba(236, 255, 240, 1)',
    color_comp_content_informativecard_urgent_bg: 'rgba(236, 255, 240, 1)',
    color_feedback_error_font_50: 'rgba(159, 0, 0, 1)',
    color_feedback_error_font_mainsection_50: 'rgba(159, 0, 0, 1)',
    color_feedback_error_font_100: 'rgba(159, 0, 0, 1)',
    color_feedback_error_font_onsurface_50: 'rgba(159, 0, 0, 1)',
    color_comp_status_tag_dandernofeedback_font: 'rgba(255, 255, 255, 1)',
    color_feedback_error_icon_50: 'rgba(159, 0, 0, 1)',
    color_comp_actions_feedbackbutton_negative_icon: 'rgba(159, 0, 0, 1)',
    color_feedback_error_icon_100: 'rgba(159, 0, 0, 1)',
    color_feedback_error_icon_onsurface_50: 'rgba(159, 0, 0, 1)',
    color_comp_status_tag_dandernofeedback_icon: 'rgba(255, 255, 255, 1)',
    color_feedback_error_border_50: 'rgba(159, 0, 0, 1)',
    color_comp_actions_feedbackbutton_negative_border: 'rgba(159, 0, 0, 1)',
    color_feedback_error_border_mainsection_50: 'rgba(159, 0, 0, 1)',
    color_feedback_error_border_75: 'rgba(159, 0, 0, 1)',
    color_feedback_error_border_100: 'rgba(159, 0, 0, 1)',
    color_feedback_error_bg_50: 'rgba(159, 0, 0, 1)',
    color_feedback_error_bg_75: 'rgba(159, 0, 0, 1)',
    color_feedback_error_bg_100: 'rgba(255, 255, 255, 1)',
    color_feedback_error_bg_mainsection_50: 'rgba(255, 255, 255, 1)',
    color_feedback_error_bg_200: 'rgba(255, 255, 255, 1)',
    color_feedback_error_bg_mainsection_100: 'rgba(255, 255, 255, 1)',
    color_feedback_error_bg_300: 'rgba(255, 234, 227, 1)',
    color_comp_actions_feedbackbutton_negative_bg: 'rgba(255, 234, 227, 1)',
    color_accent_unselected_onunselected_icon_50: 'rgba(5, 56, 64, 1)',
    color_accent_unselected_bg_50: 'rgba(255, 255, 255, 1)',
    color_accent_selected_onselected_icon_50: 'rgba(255, 255, 255, 1)',
    color_accent_selected_border_50: 'rgba(5, 56, 64, 1)',
    color_accent_selected_icon_50: 'rgba(5, 56, 64, 1)',
    color_accent_selected_bg_50: 'rgba(5, 56, 64, 1)',
    color_accent_selected_bg_100: 'rgba(5, 56, 64, 1)',
    color_accent_selected_bg_200: 'rgba(230, 255, 255, 1)',
    color_accent_default_primary_font_50: 'rgba(255, 255, 255, 1)',
    color_accent_default_primary_font_100: 'rgba(6, 113, 128, 1)',
    color_comp_navigation_link_primary_font: 'rgba(6, 113, 128, 1)',
    color_comp_navigation_link_primary_pressed_font: 'rgba(6, 113, 128, 1)',
    color_accent_default_primary_font_150: 'rgba(255, 255, 255, 1)',
    color_accent_default_secondary_font_50: 'rgba(5, 56, 64, 1)',
    color_accent_default_primary_font_200: 'rgba(6, 113, 128, 1)',
    color_accent_default_secondary_font_200: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_link_secondary_font: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_link_secondary_pressed_font: 'rgba(5, 56, 64, 1)',
    color_accent_default_primary_icon_50: 'rgba(255, 255, 255, 1)',
    color_accent_default_primary_icon_100: 'rgba(6, 113, 128, 1)',
    color_comp_navigation_link_primary_icon: 'rgba(6, 113, 128, 1)',
    color_comp_navigation_link_primary_pressed_icon: 'rgba(6, 113, 128, 1)',
    color_accent_default_primary_icon_150: 'rgba(6, 113, 128, 1)',
    color_accent_default_secondary_icon_50: 'rgba(5, 56, 64, 1)',
    color_accent_default_secondary_icon_100: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_link_secondary_icon: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_link_secondary_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_accent_default_primary_border_50: 'rgba(5, 56, 64, 1)',
    color_accent_default_primary_border_100: 'rgba(255, 255, 255, 0)',
    color_accent_default_secondary_border_50: 'rgba(5, 56, 64, 1)',
    color_accent_default_primary_bg_50: 'rgba(10, 89, 101, 1)',
    color_accent_default_primary_bg_100: 'rgba(6, 113, 128, 1)',
    color_accent_default_secondary_bg_50: 'rgba(255, 255, 255, 0)',
    color_accent_pressed_primary_font_50: 'rgba(255, 255, 255, 1)',
    color_accent_pressed_primary_icon_50: 'rgba(255, 255, 255, 1)',
    color_accent_pressed_primary_font_100: 'rgba(6, 113, 128, 1)',
    color_accent_pressed_primary_icon_100: 'rgba(6, 113, 128, 1)',
    color_accent_pressed_primary_font_150: 'rgba(255, 255, 255, 1)',
    color_accent_pressed_primary_font_200: 'rgba(6, 113, 128, 1)',
    color_accent_pressed_primary_bg_50: 'rgba(10, 89, 101, 1)',
    color_accent_pressed_primary_icon_150: 'rgba(255, 255, 255, 1)',
    color_accent_pressed_primary_border_50: 'rgba(255, 255, 255, 0)',
    color_accent_pressed_secondary_font_50: 'rgba(5, 56, 64, 1)',
    color_accent_pressed_secondary_font_200: 'rgba(5, 56, 64, 1)',
    color_accent_pressed_secondary_font_250: 'rgba(5, 56, 64, 1)',
    color_accent_pressed_secondary_icon_50: 'rgba(5, 56, 64, 1)',
    color_accent_pressed_secondary_icon_200: 'rgba(5, 56, 64, 1)',
    color_accent_pressed_secondary_icon_250: 'rgba(5, 56, 64, 1)',
    color_accent_pressed_secondary_border_50: 'rgba(5, 56, 64, 1)',
    color_accent_pressed_secondary_bg_50: 'rgba(255, 255, 255, 0)',
    color_accent_pressed_primary_bg_100: 'rgba(246, 250, 251, 1)',
    color_accent_active_primary_border_50: 'rgba(5, 56, 64, 1)',
    color_accent_pressed_primary_bg_150: 'rgba(6, 113, 128, 1)',
    color_accent_pressed_primary_bg_200: 'rgba(230, 255, 255, 1)',
    color_accent_active_primary_border_100: 'rgba(10, 89, 101, 1)',
    color_accent_active_primary_border_mainsection_50: 'rgba(5, 56, 64, 1)',
    color_accent_loading_primary_icon_50: 'rgba(145, 170, 173, 1)',
    color_accent_loading_primary_bg_50: 'rgba(221, 229, 231, 1)',
    color_accent_loading_secondary_border_50: 'rgba(145, 170, 173, 1)',
    color_accent_loading_secondary_icon_50: 'rgba(145, 170, 173, 1)',
    color_comp_status_loader_secondary_bg: 'rgba(5, 56, 64, 1)',
    size_comp_status_loader_secondary_size_small: '1.5rem',
    color_comp_status_loader_secondary_track_bg: 'rgba(5, 56, 64, 1)',
    color_comp_status_loader_secondaryforinputs_bg: 'rgba(5, 56, 64, 1)',
    color_comp_status_loader_secondaryforinputs_track_bg: 'rgba(5, 56, 64, 1)',
    color_comp_status_loader_loaderbuttonsecondary_bg: 'rgba(5, 56, 64, 1)',
    color_comp_status_loader_loaderbuttonsecondary_track_bg: 'rgba(5, 56, 64, 1)',
    color_accent_loading_secondary_bg_50: 'rgba(255, 255, 255, 0)',
    color_accent_keyboardfocus_border_50: 'rgba(255, 255, 255, 1)',
    color_accent_keyboardfocus_border_100: 'rgba(206, 112, 24, 1)',
    color_accent_disabled_font_50: 'rgba(36, 36, 36, 1)',
    color_comp_navigation_navbar_unselected_font: 'rgba(36, 36, 36, 1)',
    color_comp_navigation_navbar_unselected_icon: 'rgba(36, 36, 36, 1)',
    color_accent_disabled_font_mainsection_50: 'rgba(36, 36, 36, 1)',
    color_accent_disabled_icon_50: 'rgba(36, 36, 36, 1)',
    color_accent_disabled_icon_mainsection_50: 'rgba(95, 121, 125, 1)',
    color_accent_disabled_font_100: 'rgba(95, 121, 125, 1)',
    color_accent_disabled_font_mainsection_100: 'rgba(145, 170, 173, 1)',
    color_accent_disabled_border_50: 'rgba(95, 121, 125, 1)',
    color_accent_disabled_icon_100: 'rgba(95, 121, 125, 1)',
    color_accent_disabled_icon_mainsection_100: 'rgba(145, 170, 173, 1)',
    color_accent_disabled_font_150: 'rgba(246, 250, 251, 1)',
    color_accent_disabled_icon_150: 'rgba(246, 250, 251, 1)',
    color_accent_disabled_bg_50: 'rgba(95, 121, 125, 1)',
    color_accent_disabled_bg_100: 'rgba(221, 229, 231, 1)',
    color_accent_disabled_bg_mainsection_100: 'rgba(221, 229, 231, 1)',
    color_accent_disabled_bg_200: 'rgba(221, 229, 231, 1)',
    color_accent_disabled_bg_300: 'rgba(187, 202, 205, 1)',
    color_accent_disabled_border_100: 'rgba(145, 170, 173, 1)',
    color_accent_disabled_border_150: 'rgba(246, 250, 251, 1)',
    color_accent_loading_primary_bg_100: 'rgba(5, 56, 64, 1)',
    color_accent_active_animation_border_50: 'rgba(10, 89, 101, 1)',
    color_accent_hover_primary_font_50: 'rgba(10, 89, 101, 1)',
    color_accent_hover_primary_font_100: 'rgba(6, 113, 128, 1)',
    color_accent_hover_primary_font_150: 'rgba(255, 255, 255, 1)',
    color_accent_hover_secondary_font_50: 'rgba(10, 89, 101, 1)',
    color_accent_hover_primary_font_200: 'rgba(196, 242, 242, 1)',
    color_accent_hover_secondary_font_200: 'rgba(5, 56, 64, 1)',
    color_accent_hover_primary_icon_50: 'rgba(10, 89, 101, 1)',
    color_accent_hover_primary_icon_100: 'rgba(6, 113, 128, 1)',
    color_accent_hover_primary_icon_150: 'rgba(96, 183, 194, 1)',
    color_accent_hover_secondary_icon_50: 'rgba(10, 89, 101, 1)',
    color_accent_hover_secondary_icon_100: 'rgba(5, 56, 64, 1)',
    color_accent_hover_primary_bg_50: 'rgba(31, 127, 141, 1)',
    color_accent_hover_primary_bg_100: 'rgba(230, 255, 255, 1)',
    color_accent_hover_secondary_bg_50: 'rgba(230, 255, 255, 1)',
    color_accent_pressed_primary_icon_200: 'rgba(6, 113, 128, 1)',
    color_category_income_bg_50: 'rgba(5, 56, 64, 1)',
    color_category_income_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_expense_bg_50: 'rgba(5, 56, 64, 1)',
    color_category_expense_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_home_bg_50: 'rgba(5, 56, 64, 1)',
    color_category_home_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_expense_border_25: 'rgba(5, 56, 64, 1)',
    color_category_expense_icon_25: 'rgba(5, 56, 64, 1)',
    color_category_home_border_25: 'rgba(5, 56, 64, 1)',
    color_category_home_icon_25: 'rgba(5, 56, 64, 1)',
    color_category_income_border_25: 'rgba(5, 56, 64, 1)',
    color_category_income_icon_25: 'rgba(5, 56, 64, 1)',
    color_category_profesional_expenses_bg_50: 'rgba(5, 56, 64, 1)',
    color_category_profesional_expenses_border_25: 'rgba(5, 56, 64, 1)',
    color_category_profesional_expenses_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_profesional_expenses_icon_25: 'rgba(5, 56, 64, 1)',
    color_category_restaurants_bg_50: 'rgba(5, 56, 64, 1)',
    color_category_restaurants_border_25: 'rgba(5, 56, 64, 1)',
    color_category_restaurants_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_restaurants_icon_25: 'rgba(5, 56, 64, 1)',
    color_category_shopping_bg_50: 'rgba(5, 56, 64, 1)',
    color_category_shopping_border_25: 'rgba(5, 56, 64, 1)',
    color_category_shopping_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_shopping_icon_25: 'rgba(5, 56, 64, 1)',
    color_category_transport_bg_50: 'rgba(5, 56, 64, 1)',
    color_category_transport_border_25: 'rgba(5, 56, 64, 1)',
    color_category_transport_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_transport_icon_25: 'rgba(5, 56, 64, 1)',
    color_category_education_and_health_bg_50: 'rgba(5, 56, 64, 1)',
    color_category_education_and_health_border_25: 'rgba(5, 56, 64, 1)',
    color_category_education_and_health_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_education_and_health_icon_25: 'rgba(5, 56, 64, 1)',
    color_category_leisure_and_travel_bg_50: 'rgba(5, 56, 64, 1)',
    color_category_leisure_and_travel_border_25: 'rgba(5, 56, 64, 1)',
    color_category_leisure_and_travel_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_leisure_and_travel_icon_25: 'rgba(5, 56, 64, 1)',
    color_category_organizations_and_ong_bg_50: 'rgba(5, 56, 64, 1)',
    color_category_organizations_and_ong_border_25: 'rgba(5, 56, 64, 1)',
    color_category_organizations_and_ong_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_organizations_and_ong_icon_25: 'rgba(5, 56, 64, 1)',
    color_category_investments_and_savings_bg_50: 'rgba(5, 56, 64, 1)',
    color_category_investments_and_savings_border_25: 'rgba(5, 56, 64, 1)',
    color_category_investments_and_savings_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_investments_and_savings_icon_25: 'rgba(5, 56, 64, 1)',
    color_category_other_bg_50: 'rgba(5, 56, 64, 1)',
    color_category_other_border_25: 'rgba(5, 56, 64, 1)',
    color_category_other_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_other_icon_25: 'rgba(5, 56, 64, 1)',
    color_category_atm_bg_50: 'rgba(5, 56, 64, 1)',
    color_category_atm_border_25: 'rgba(5, 56, 64, 1)',
    color_category_atm_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_atm_icon_25: 'rgba(5, 56, 64, 1)',
    color_category_transfer_bg_50: 'rgba(5, 56, 64, 1)',
    color_category_transfer_border_25: 'rgba(5, 56, 64, 1)',
    color_category_transfer_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_transfer_icon_25: 'rgba(5, 56, 64, 1)',
    color_category_excluded_transactions_bg_50: 'rgba(5, 56, 64, 1)',
    color_category_excluded_transactions_border_25: 'rgba(5, 56, 64, 1)',
    color_category_excluded_transactions_bg_100: 'rgba(221, 229, 231, 1)',
    color_category_excluded_transactions_icon_25: 'rgba(5, 56, 64, 1)',
    color_product_accounts_bg_50: 'rgba(246, 250, 251, 1)',
    color_product_accounts_bg_100: 'rgba(255, 255, 255, 1)',
    color_product_accounts_icon_400: 'rgba(5, 56, 64, 1)',
    color_product_cards_bg_50: 'rgba(246, 250, 251, 1)',
    color_product_cards_bg_100: 'rgba(255, 255, 255, 1)',
    color_product_deposits_bg_50: 'rgba(246, 250, 251, 1)',
    color_product_deposits_bg_100: 'rgba(255, 255, 255, 1)',
    color_product_loans_bg_50: 'rgba(246, 250, 251, 1)',
    color_product_loans_bg_100: 'rgba(255, 255, 255, 1)',
    color_product_loans_icon_400: 'rgba(5, 56, 64, 1)',
    color_product_mortgages_icon_400: 'rgba(5, 56, 64, 1)',
    color_product_mortgages_bg_50: 'rgba(246, 250, 251, 1)',
    color_product_mortgages_bg_100: 'rgba(255, 255, 255, 1)',
    color_product_insurance_bg_50: 'rgba(246, 250, 251, 1)',
    color_product_insurance_bg_100: 'rgba(255, 255, 255, 1)',
    color_product_wealth_bg_50: 'rgba(246, 250, 251, 1)',
    color_product_wealth_bg_100: 'rgba(255, 255, 255, 1)',
    color_product_deposits_icon_400: 'rgba(5, 56, 64, 1)',
    color_chart_bg_50: 'rgba(204, 26, 26, 1)',
    color_chart_bg_100: 'rgba(135, 18, 57, 1)',
    color_chart_bg_150: 'rgba(177, 81, 102, 1)',
    color_chart_bg_200: 'rgba(76, 84, 164, 1)',
    color_chart_bg_250: 'rgba(122, 133, 237, 1)',
    color_chart_bg_300: 'rgba(58, 97, 139, 1)',
    color_chart_bg_325: 'rgba(5, 56, 64, 1)',
    color_chart_bg_350: 'rgba(88, 120, 155, 1)',
    color_chart_bg_400: 'rgba(18, 135, 43, 1)',
    color_chart_bg_450: 'rgba(6, 113, 128, 1)',
    color_chart_bg_500: 'rgba(132, 119, 1, 1)',
    color_chart_bg_525: 'rgba(127, 153, 159, 1)',
    color_chart_bg_550: 'rgba(206, 112, 24, 1)',
    color_chart_bg_600: 'rgba(169, 89, 13, 1)',
    color_chart_bg_opacity_200: 'rgba(103, 58, 183, 0.24705882352941178)',
    color_chart_bg_opacity_50: 'rgba(204, 26, 26, 0.24705882352941178)',
    color_chart_bg_opacity_100: 'rgba(135, 18, 57, 0.24705882352941178)',
    color_chart_bg_opacity_150: 'rgba(242, 120, 120, 0.24705882352941178)',
    color_chart_bg_opacity_250: 'rgba(76, 84, 164, 0.24705882352941178)',
    color_chart_bg_opacity_300: 'rgba(122, 237, 224, 0.24705882352941178)',
    color_chart_bg_opacity_325: 'rgba(58, 97, 139, 0.24705882352941178)',
    color_chart_bg_opacity_350: 'rgba(31, 181, 165, 0.24705882352941178)',
    color_chart_bg_opacity_400: 'rgba(18, 135, 43, 0.24705882352941178)',
    color_chart_bg_opacity_450: 'rgba(199, 188, 25, 0.24705882352941178)',
    color_chart_bg_opacity_500: 'rgba(114, 60, 9, 0.24705882352941178)',
    color_chart_bg_opacity_525: 'rgba(242, 161, 84, 0.24705882352941178)',
    color_chart_bg_opacity_550: 'rgba(209, 114, 24, 0.24705882352941178)',
    color_chart_bg_opacity_600: 'rgba(97, 92, 10, 0.24705882352941178)',
    color_chart_bg_opacity_700: 'rgba(255, 255, 255, 0.4980392156862745)',
    color_chart_crypto_bg_btc: 'rgba(197, 111, 7, 1)',
    color_chart_crypto_bg_eth: 'rgba(150, 99, 233, 1)',
    color_chart_crypto_bg_dot: 'rgba(230, 0, 116, 1)',
    color_chart_crypto_bg_ltc: 'rgba(83, 127, 198, 1)',
    color_chart_crypto_bg_avax: 'rgba(232, 65, 66, 1)',
    color_chart_crypto_bg_matic: 'rgba(125, 26, 255, 1)',
    color_chart_crypto_bg_ada: 'rgba(51, 112, 255, 1)',
    color_chart_crypto_bg_algo: 'rgba(0, 0, 0, 1)',
    color_chart_crypto_bg_atom: 'rgba(115, 121, 165, 1)',
    color_effect_focus_50: 'rgba(255, 255, 255, 1)',
    color_effect_focus_100: 'rgba(206, 112, 24, 1)',
    color_effect_shadow_drop_50: 'rgba(5, 56, 64, 0.2980392156862745)',
    color_effect_shadow_drop_75: 'rgba(5, 56, 64, 0.14901960784313725)',
    color_effect_shadow_drop_100: 'rgba(5, 56, 64, 0.2980392156862745)',
    color_exception_accent_default_secondary_icon_100: 'rgba(5, 56, 64, 1)',
    color_effect_shadow_drop_110: 'rgba(255, 255, 255, 0)',
    color_exception_accent_default_secondary_icon_125: 'rgba(5, 56, 64, 1)',
    color_effect_shadow_drop_150: 'rgba(255, 255, 255, 0)',
    color_effect_shadow_inner_50: 'rgba(5, 56, 64, 0.2980392156862745)',
    color_accent_default_secondary_icon_200: 'rgba(5, 56, 64, 1)',
    color_exception_accent_default_secondary_icon_250: 'rgba(255, 255, 255, 1)',
    color_neutral_bg_325: 'rgba(255, 255, 255, 1)',
    color_comp_navigation_link_techonly_icon: 'rgba(5, 56, 64, 1)',
    color_exception_accent_default_secondary_font_50: 'rgba(5, 56, 64, 1)',
    color_neutral_bg_350: 'rgba(5, 56, 64, 1)',
    color_neutral_bg_500: 'rgba(95, 121, 125, 1)',
    color_comp_navigation_link_techonly_font: 'rgba(5, 56, 64, 1)',
    color_exception_neutral_bg_750: 'rgba(246, 250, 251, 1)',
    color_accent_default_secondary_font_150: 'rgba(5, 56, 64, 1)',
    color_neutral_bg_onsurface_150: 'rgba(246, 250, 251, 1)',
    color_accent_default_secondary_border_100: 'rgba(5, 56, 64, 1)',
    color_exception_neutral_font_350: 'rgba(5, 56, 64, 1)',
    color_exception_neutral_font_375: 'rgba(5, 56, 64, 1)',
    color_accent_default_secondary_bg_100: 'rgba(255, 255, 255, 0)',
    color_exception_neutral_icon_400: 'rgba(5, 56, 64, 1)',
    color_exception_neutral_icon_450: 'rgba(5, 56, 64, 1)',
    color_exception_accent_default_tertiary_bg_50: 'rgba(255, 255, 255, 0)',
    color_exception_accent_default_tertiary_border_50: 'rgba(5, 56, 64, 1)',
    color_exception_neutral_border_200: 'rgba(5, 56, 64, 1)',
    color_animation_bg_50: 'rgba(122, 237, 224, 1)',
    color_decorative_bg_50: 'rgba(230, 255, 255, 1)',
    color_animation_bg_100: 'rgba(242, 161, 84, 1)',
    color_neutral_border_200: 'rgba(255, 255, 255, 1)',
    color_exception_accent_pressed_secondary_icon_50: 'rgba(5, 56, 64, 1)',
    color_neutral_border_355: 'rgba(145, 170, 173, 1)',
    color_exception_neutral_border_100: 'rgba(95, 121, 125, 1)',
    color_neutral_bg_800: 'rgba(255, 255, 255, 1)',
    color_exception_neutral_bg_1350: 'rgba(255, 255, 255, 0)',
    color_comp_navigation_primarytabs_unselected_bg: 'rgba(255, 255, 255, 0)',
    color_neutral_bg_onsurface_50: 'rgba(36, 36, 36, 1)',
    color_neutral_bg_onsurface_55: 'rgba(95, 121, 125, 1)',
    color_neutral_bg_onsurface_65: 'rgba(187, 202, 205, 1)',
    color_neutral_bg_onsurface_100: 'rgba(246, 250, 251, 1)',
    color_comp_tableslist_table_regular_bg: 'rgba(246, 250, 251, 1)',
    color_comp_content_pdfthumbnail_bg: 'rgba(246, 250, 251, 1)',
    color_comp_commercial_commercialcard_default_bg: 'rgba(246, 250, 251, 1)',
    color_neutral_bg_onsurface_200: 'rgba(255, 255, 255, 0)',
    color_comp_navigation_breadcrumbs_default_icon: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_breadcrumbs_default_font: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_breadcrumbs_currentpage_font: 'rgba(5, 56, 64, 1)',
    color_neutral_font_onsurface_200: 'rgba(95, 121, 125, 1)',
    color_neutral_icon_onsurface_50: 'rgba(5, 56, 64, 1)',
    color_neutral_border_onsurface_100: 'rgba(95, 121, 125, 1)',
    color_neutral_border_onsurface_150: 'rgba(5, 56, 64, 1)',
    color_exception_secondary_bg_550: 'rgba(246, 250, 251, 1)',
    color_exception_secondary_bg_50: 'rgba(204, 26, 26, 1)',
    color_exception_secondary_font_50: 'rgba(255, 255, 255, 1)',
    color_exception_secondary_border_50: 'rgba(255, 255, 255, 1)',
    color_exception_feedback_error_icon_50: 'rgba(159, 0, 0, 1)',
    color_exception_feedback_error_bg_400: 'rgba(255, 234, 227, 1)',
    color_exception_feedback_success_bg_250: 'rgba(236, 255, 240, 1)',
    color_brand_bg_150: 'rgba(5, 56, 64, 1)',
    color_brand_bg_200: 'rgba(5, 56, 64, 1)',
    color_exception_brand_icon_50: 'rgba(5, 56, 64, 1)',
    color_brand_bg_250: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_primarytabs_selected_border: 'rgba(206, 112, 24, 1)',
    color_exception_accent_selected_bg_100: 'rgba(5, 56, 64, 0.14901960784313725)',
    color_exception_accent_pressed_primary_icon_100: 'rgba(255, 255, 255, 1)',
    color_comp_navigation_link_techonly_pressed_font: 'rgba(5, 56, 64, 1)',
    color_accent_pressed_secondary_font_150: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_link_techonly_pressed_icon: 'rgba(5, 56, 64, 1)',
    color_accent_pressed_secondary_icon_150: 'rgba(5, 56, 64, 1)',
    color_accent_pressed_secondary_border_100: 'rgba(5, 56, 64, 1)',
    color_accent_pressed_secondary_bg_100: 'rgba(255, 255, 255, 0)',
    color_exception_accent_pressed_secondary_bg_50: 'rgba(255, 255, 255, 0)',
    color_exception_accent_loading_primary_icon_50: 'rgba(145, 170, 173, 1)',
    color_comp_status_loader_loaderbuttonprimary_bg: 'rgba(5, 56, 64, 1)',
    color_comp_status_loader_loaderbuttonprimary_track_bg: 'rgba(5, 56, 64, 1)',
    color_accent_loading_secondary_border_100: 'rgba(145, 170, 173, 1)',
    color_accent_loading_secondary_icon_100: 'rgba(145, 170, 173, 1)',
    color_comp_status_loader_loaderbuttontechonly_bg: 'rgba(5, 56, 64, 1)',
    color_comp_status_loader_loaderbuttontechonly_track_bg: 'rgba(5, 56, 64, 1)',
    color_comp_status_loader_loadernotifications_bg: 'rgba(255, 255, 255, 1)',
    color_comp_status_loader_loadernotifications_track_bg: 'rgba(255, 255, 255, 1)',
    color_comp_status_loader_contact_center_loaderbuttonprimary_bg: 'rgba(255, 255, 255, 1)',
    color_comp_status_loader_contact_center_loaderbuttonsecondary_bg: 'rgba(62, 35, 110, 1)',
    color_comp_status_loader_contactcenterforinputs_bg: 'rgba(62, 35, 110, 1)',
    color_exception_accent_loading_secondary_icon_150: 'rgba(255, 255, 255, 1)',
    color_exception_accent_loading_secondary_bg_50: 'rgba(5, 56, 64, 1)',
    color_accent_loading_secondary_bg_100: 'rgba(255, 255, 255, 0)',
    color_exception_accent_icon_50: 'rgba(5, 56, 64, 1)',
    color_exception_accent_icon_100: 'rgba(5, 56, 64, 1)',
    color_exception_product_icon_50: 'rgba(5, 56, 64, 1)',
    color_exception_accent_hover_secondary_font_100_onsurface: 'rgba(5, 56, 64, 1)',
    color_exception_accent_hover_secondary_icon_100_onsurface: 'rgba(5, 56, 64, 1)',
    color_exception_accent_hover_secondary_bg_quickbutton_secondary: 'rgba(255, 255, 255, 0)',
    color_comp_navigation_primarytabs_hover_bg: 'rgba(246, 250, 251, 1)',
    color_comp_navigation_primarytabs_hover_font: 'rgba(95, 121, 125, 1)',
    color_accent_pressed_bgcolor: 'rgba(230, 255, 255, 1)',
    color_accent_unselected_onunselected_font_50: 'rgba(5, 56, 64, 1)',
    border_comp_navigation_primarytabs_bordersize: '0.25rem',
    color_comp_resources_avatarprofile_initials_font: 'rgba(5, 56, 64, 1)',
    color_comp_resources_avatarprofile_selector_bg: 'rgba(255, 255, 255, 1)',
    color_comp_resources_avatarprofile_initials_bg: 'rgba(246, 250, 251, 1)',
    color_comp_resources_avatarprofile_initials_default_border: 'rgba(95, 121, 125, 1)',
    color_comp_resources_avatarprofile_empty_default_border: 'rgba(5, 56, 64, 1)',
    color_comp_resources_dot_font: 'rgba(255, 255, 255, 1)',
    color_comp_resources_dot_bg: 'rgba(204, 26, 26, 1)',
    color_comp_resources_dot_border: 'rgba(255, 255, 255, 1)',
    font_exception_weight_paragraph_dot: 600,
    font_exception_size_paragraph_dot: '0.75rem',
    font_comp_resources_dot_fontsize_medium: '1rem',
    font_exception_line_height_paragraph_dot: '1rem',
    font_comp_resources_dot_fontlineheight_medium: '1.25rem',
    size_comp_resources_dot_size_small: '1rem',
    size_comp_resources_dot_size_medium: '1.5rem',
    color_comp_resources_iconhighlighted_bg: 'rgba(246, 250, 251, 1)',
    color_comp_resources_iconhighlighted_square_icon: 'rgba(5, 56, 64, 1)',
    color_comp_resources_selectionindicator_default_selected_icon: 'rgba(255, 255, 255, 1)',
    radius_comp_resources_virtualkeyboard_radiussize: '0.75rem',
    color_comp_status_progressbar_chart_font: 'rgba(5, 56, 64, 1)',
    color_comp_status_progressbar_chart_empty_bg: 'rgba(127, 153, 159, 1)',
    color_comp_status_progressbar_chart_filled_bg: 'rgba(5, 56, 64, 1)',
    color_comp_status_progressbar_linear_regular_empty_bg: 'rgba(127, 153, 159, 1)',
    color_comp_status_progressbar_linear_regular_filled_bg: 'rgba(5, 56, 64, 1)',
    color_comp_status_progressbar_segmented_filled_bg: 'rgba(5, 56, 64, 1)',
    color_comp_status_progressbar_segmented_empty_bg: 'rgba(127, 153, 159, 1)',
    color_neutral_bg_skeleton_100: 'rgba(246, 250, 251, 1)',
    color_neutral_bg_skeleton_50: 'rgba(255, 255, 255, 1)',
    color_comp_navigation_browsertabs_selected_bg: 'rgba(246, 250, 251, 1)',
    color_comp_navigation_browsertabs_selected_border: 'rgba(206, 112, 24, 1)',
    color_comp_navigation_browsertabs_hover_bg: 'rgba(246, 250, 251, 1)',
    color_comp_navigation_navbar_selected_font: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_navbar_selected_icon: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_navbar_selected_line_bg: 'rgba(206, 112, 24, 1)',
    color_comp_navigation_navigationcard_bgiconhighlighted: 'rgba(255, 255, 255, 1)',
    radius_comp_navigation_navigationcard_borderradius: '1rem',
    radius_comp_navigation_navigationcard_radiussizesmall: '0.25rem',
    color_comp_navigation_navigationstatuscard_font: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_navigationstatuscard_icon: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_navigationstatuscard_iconhighlighted: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_navigationstatuscard_blocked_bg: 'rgba(255, 234, 227, 1)',
    color_comp_navigation_navigationstatuscard_success_bg: 'rgba(236, 255, 240, 1)',
    color_comp_navigation_pagecontrol_default_icon: 'rgba(0, 0, 0, 0.6)',
    color_comp_navigation_scrollcontroller_track_bg: 'rgba(84, 102, 109, 1)',
    color_comp_navigation_pagecontroltechonly_lastpage_border: 'rgba(255, 255, 255, 0)',
    color_comp_navigation_pagecontroltechonly_lastpage_icon: 'rgba(0, 0, 0, 0.6)',
    color_comp_navigation_pagecontroltechonly_default_icon: 'rgba(0, 0, 0, 0.6)',
    color_comp_navigation_pagecontrol_techonly_active_icon: 'rgba(122, 237, 224, 1)',
    color_comp_navigation_pagecontrol_lastpage_icon: 'rgba(0, 0, 0, 0.6)',
    color_comp_navigation_pagecontrol_default_border: 'rgba(255, 255, 255, 0)',
    color_comp_navigation_pagination_selected_font: 'rgba(255, 255, 255, 1)',
    color_comp_navigation_pagination_selected_icon: 'rgba(10, 111, 101, 1)',
    color_comp_navigation_stepper_active_bg: 'rgba(6, 113, 128, 1)',
    color_comp_navigation_stepper_completed_icon: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_stepper_completed_track_bg: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_pagecontrol_currentpage_icon: 'rgba(5, 56, 64, 1)',
    color_comp_navigation_scrollcontroller_bar_bg: 'rgba(122, 237, 224, 1)',
    color_comp_tableslist_lineseparator_regular_border: 'rgba(145, 170, 173, 1)',
    color_comp_tableslist_lineseparator_decorative_border: 'rgba(187, 202, 205, 1)',
    color_comp_tableslist_lineseparator_onsurface_border: 'rgba(145, 170, 173, 1)',
    color_comp_tableslist_tablecells_bg: 'rgba(246, 250, 251, 1)',
    spacing_00: '0rem',
    spacing_25: '0.0625rem',
    spacing_50: '0.125rem',
    spacing_75: '0.1875rem',
    spacing_100: '0.25rem',
    spacing_125: '0.375rem',
    spacing_150: '0.5rem',
    spacing_200: '0.75rem',
    spacing_225: '0.875rem',
    spacing_250: '1rem',
    spacing_275: '1.25rem',
    spacing_300: '1.5rem',
    spacing_350: '2rem',
    spacing_400: '2.5rem',
    spacing_450: '3rem',
    spacing_500: '3.5rem',
    spacing_550: '4rem',
    spacing_555: '4.5rem',
    spacing_558: '5.25rem',
    spacing_575: '7.5rem',
    spacing_600: '8rem',
    radius_00: '0rem',
    radius_50: '0.125rem',
    radius_100: '0.25rem',
    radius_125: '0.375rem',
    radius_150: '0.5rem',
    radius_200: '0.75rem',
    radius_250: '1rem',
    radius_275: '1.0625rem',
    radius_285: '1.125rem',
    radius_300: '1.5rem',
    radius_350: '2rem',
    size_00: '0rem',
    radius_1000: '22.5rem',
    size_25: '0.03125rem',
    size_38: '0.125rem',
    size_50: '0.25rem',
    size_75: '0.375rem',
    size_100: '0.5rem',
    size_125: '0.625rem',
    size_150: '0.75rem',
    size_200: '1rem',
    size_250: '1.25rem',
    size_300: '1.5rem',
    size_325: '1.75rem',
    size_350: '2rem',
    size_375: '2.125rem',
    size_385: '2.25rem',
    size_400: '2.5rem',
    size_425: '2.75rem',
    size_450: '3rem',
    size_475: '3.25rem',
    size_480: '3.375rem',
    size_500: '3.5rem',
    size_525: '3.75rem',
    size_550: '4rem',
    size_575: '4.375rem',
    size_loader_primary: '4.5rem',
    size_600: '4.5rem',
    size_625: '4.875rem',
    size_650: '5rem',
    size_675: '5.75rem',
    size_680: '5.875rem',
    size_700: '6rem',
    size_725: '6.125rem',
    size_750: '6.5rem',
    size_800: '7rem',
    size_850: '7.5rem',
    size_900: '8rem',
    size_950: '8.5rem',
    size_975: '8.75rem',
    size_1000: '9rem',
    size_1025: '9.25rem',
    border_00: '0rem',
    size_1050: '9.5rem',
    border_25: '0.03125rem',
    border_50: '0.0625rem',
    border_75: '0.09375rem',
    border_100: '0.125rem',
    border_125: '0.1875rem',
    border_150: '0.25rem',
    size_1075: '9.75rem',
    size_1088: '10rem',
    radius_button_small: '1rem',
    radius_button_large: '1.5rem',
    size_1089: '10.25rem',
    size_1080: '11.75rem',
    size_1083: '12.125rem',
    size_1091: '12.1875rem',
    size_1100: '12.5rem',
    size_1110: '13rem',
    size_1125: '13.375rem',
    size_1135: '14.5rem',
    size_1150: '14.875rem',
    size_1175: '14.9375rem',
    size_1177: '15rem',
    size_1177_2: '15rem',
    size_1176: '15.5rem',
    size_1180: '16.5rem',
    size_1181: '17.8125rem',
    size_1183: '18.5rem',
    size_1184: '18.75rem',
    size_1185: '19.5rem',
    size_1186: '20rem',
    size_1200: '20.5rem',
    size_1225: '21.75rem',
    size_1228: '22.75rem',
    size_1230: '27rem',
    size_1238: '28rem',
    size_1250: '30rem',
    size_1275: '39.5rem',
    size_1300: '45rem',
    size_1500: '57.5rem',
    alpha_50: '0',
    alpha_100: '0.1',
    alpha_150: '0.2',
    alpha_200: '0.3',
    alpha_250: '0.4',
    alpha_300: '0.5',
    alpha_350: '0.6',
    alpha_400: '0.7',
    alpha_450: '0.8',
    alpha_500: '0.9',
    alpha_550: '1',
    duration_50: '0.001s',
    blur_00: '0rem',
    blur_25: '0.125rem',
    spread_00: '0rem',
    spread_25: '0.125rem',
    spread_50: '0.1875rem',
    spread_100: '0.375rem',
    spread_negative_50: '-0.125rem',
    blur_50: '0.25rem',
    blur_100: '0.5rem',
    blur_150: '0.9375rem',
    duration_100: '0.15s',
    font_family_heading: 'Noto Sans',
    font_family_paragraph: 'Noto Sans',
    font_weight_heading_xllm_display_4xl_light: 300,
    font_style_light_italic: 'Light Italic',
    font_style_italic: 'Italic',
    font_style_bold_italic: 'Bold Italic',
    font_weight_heading_xllm_display_3xl_light: 300,
    font_weight_heading_xllm_display_3xl_regular: 400,
    font_weight_heading_xllm_display_3xl_bold: 600,
    font_weight_heading_xllm_display_4xl_regular: 400,
    font_weight_heading_xllm_display_4xl_bold: 600,
    font_weight_heading_xllm_display_2xl_light: 300,
    font_weight_heading_xllm_display_2xl_regular: 400,
    font_weight_heading_xllm_display_2xl_bold: 600,
    font_weight_heading_xllm_display_xl_light: 300,
    font_weight_heading_xllm_display_xl_regular: 400,
    font_weight_heading_xllm_display_xl_bold: 600,
    font_weight_heading_xllm_display_1_light: 300,
    font_weight_heading_xllm_display_1_regular: 400,
    font_weight_heading_xllm_display_1_bold: 600,
    font_weight_heading_xllm_display_2_light: 300,
    font_weight_heading_xllm_display_2_regular: 400,
    font_weight_heading_xllm_display_2_bold: 600,
    font_weight_heading_xllm_h_regular: 400,
    font_weight_heading_xllm_h_bold: 600,
    font_weight_heading_xllm_h1_regular: 400,
    font_weight_heading_xllm_h1_bold: 600,
    font_weight_heading_xllm_h2_regular: 400,
    font_weight_heading_xllm_h2_bold: 600,
    font_weight_heading_s_display_4xl_light: 300,
    font_weight_heading_s_display_4xl_regular: 400,
    font_weight_heading_s_display_4xl_bold: 600,
    font_weight_heading_s_display_3xl_light: 300,
    font_weight_heading_s_display_2xl_light: 300,
    font_weight_heading_s_display_2xl_regular: 400,
    font_weight_heading_s_display_2xl_bold: 600,
    font_weight_heading_s_display_3xl_regular: 400,
    font_weight_heading_s_display_3xl_bold: 600,
    font_weight_heading_s_display_xl_light: 300,
    font_weight_heading_s_display_xl_regular: 400,
    font_weight_heading_s_display_xl_bold: 600,
    font_weight_heading_s_display_1_light: 300,
    font_weight_heading_s_display_1_regular: 400,
    font_weight_heading_s_display_1_bold: 600,
    font_weight_heading_s_display_2_light: 300,
    font_weight_heading_s_display_2_regular: 400,
    font_weight_heading_s_h_regular: 400,
    font_weight_heading_s_h_bold: 600,
    font_weight_heading_s_display_2_bold: 600,
    font_weight_heading_s_h1_regular: 400,
    font_weight_heading_s_h1_bold: 600,
    font_weight_heading_s_h2_regular: 400,
    font_weight_heading_s_h2_bold: 600,
    font_weight_heading_title_ds_bold: 600,
    font_weight_heading_title_ds_light: 300,
    font_weight_paragraph_large_regular: 400,
    font_weight_paragraph_large_bold: 600,
    font_weight_paragraph_medium_regular: 400,
    font_weight_paragraph_medium_bold: 600,
    font_weight_paragraph_small_regular: 400,
    font_weight_paragraph_small_bold: 600,
    font_weight_caption_medium_regular: 400,
    font_weight_caption_medium_bold: 600,
    font_weight_caption_small_regular: 400,
    font_weight_caption_small_bold: 600,
    font_size_heading_xllm_display_4xl: '6rem',
    font_size_heading_xllm_display_3xl: '5.5rem',
    font_size_heading_xllm_display_2xl: '4.5rem',
    font_size_heading_xllm_display_xl: '4rem',
    font_size_heading_xllm_display_1: '3.375rem',
    font_size_heading_xllm_display_2: '3rem',
    font_size_heading_xllm_h: '2rem',
    font_size_heading_xllm_h1: '1.75rem',
    font_size_heading_s_display_4xl: '4.75rem',
    font_size_heading_s_display_3xl: '4.25rem',
    font_size_heading_xllm_h2: '1.5rem',
    font_size_heading_s_display_2xl: '3.75rem',
    font_size_heading_s_display_xl: '3.25rem',
    font_size_heading_s_display_1: '2.75rem',
    font_size_heading_s_display_2: '2.25rem',
    font_size_heading_s_h: '1.625rem',
    font_size_heading_s_h1: '1.5rem',
    font_size_heading_s_h2: '1.25rem',
    font_size_heading_title_ds: '1.25rem',
    font_size_heading_title_ds_50: '1.25rem',
    font_size_paragraph_large: '1.125rem',
    font_size_paragraph_medium: '1rem',
    font_size_paragraph_small: '0.875rem',
    font_line_height_heading_xllm_display_4xl: '6.75rem',
    font_line_height_heading_xllm_display_3xl: '6.5rem',
    font_line_height_heading_xllm_display_2xl: '5.25rem',
    font_size_caption_medium: '0.75rem',
    font_line_height_heading_xllm_display_xl: '4.75rem',
    font_size_caption_small: '0.625rem',
    font_line_height_heading_xllm_display_1: '3.875rem',
    font_line_height_heading_xllm_display_2: '3.5rem',
    font_line_height_heading_xllm_h: '2.375rem',
    font_line_height_heading_xllm_h1: '2rem',
    font_line_height_heading_xllm_h2: '2rem',
    font_line_height_heading_s_display_4xl: '5.5rem',
    font_line_height_heading_s_display_3xl: '4.75rem',
    font_line_height_heading_s_display_2xl: '4.5rem',
    font_line_height_heading_s_display_xl: '4rem',
    font_line_height_heading_s_display_1: '3.25rem',
    font_line_height_heading_s_display_2: '2.625rem',
    font_line_height_heading_s_h: '2rem',
    font_line_height_heading_s_h1: '2rem',
    font_line_height_heading_s_h2: '1.5rem',
    font_line_height_heading_title_ds: '1.5rem',
    font_line_height_heading_title_ds_50: '1.5rem',
    font_line_height_paragraph_large: '1.5rem',
    font_line_height_paragraph_medium: '1.5rem',
    font_line_height_paragraph_small: '1.25rem',
    font_line_height_caption_medium: '1rem',
    font_line_height_caption_small: '0.875rem',
    font_exception_weight_paragraph_avatar_l: 400,
    font_exception_size_paragraph_avatar_l: '1.75rem',
    font_exception_size_paragraph_avatar_ms: '1.5rem',
    font_exception_size_paragraph_avatar_xs: '1.125rem',
    font_exception_size_paragraph_avatar_xxs: '0.75rem',
    font_exception_size_paragraph_input_currency: '3.25rem',
    font_exception_line_height_paragraph_avatar_l: '2rem',
    font_exception_line_height_paragraph_avatar_ms: '2rem',
    font_exception_line_height_paragraph_avatar_xs: '1.5rem',
    font_exception_line_height_paragraph_avatar_xxs: '1rem',
    font_exception_line_height_paragraph_input_currency: '4.6875rem',
    font_exception_weight_paragraph_avatar_ms: 400,
    font_exception_weight_paragraph_avatar_xs: 400,
    font_exception_weight_paragraph_avatar_xxs: 400,
    font_exception_weight_paragraph_input_currency: 600,
    duration_125: '0.25s',
    duration_150: '0.3s',
    duration_175: '0.5s',
    duration_200: '0.8s',
    duration_250: '1s',
    duration_300: '1.2s',
    duration_400: '0.6s',
    color_comp_status_loader_bubble_bg: 'rgba(5, 56, 64, 1)',
    color_comp_status_loader_chat_dots_bg: 'rgba(31, 127, 141, 1)',
    color_comp_status_loader_chat_iconcontainer_bg: 'rgba(122, 237, 224, 1)',
    color_comp_status_loader_chat_icon_icon: 'rgba(5, 56, 64, 1)',
    color_neutral_bg_400: 'rgba(255, 255, 255, 0)',
    spacing_negative_100: '-0.25rem',
    spacing_overlap_xs: '-0.25rem',
    spacing_overlap_s: '-0.5rem',
    spacing_overlap_m: '-1rem',
    spacing_overlap_l: '-1.5rem',
    spacing_negative_150: '-0.5rem',
    spacing_negative_200: '-0.75rem',
    spacing_negative_250: '-1rem',
    spacing_negative_300: '-1.5rem',
    spacing_negative_350: '-2rem',
    spacing_negative_360: '-2.5rem',
    spacing_negative_370: '-3rem',
    spacing_negative_380: '-3.5rem',
    spacing_negative_400: '-4rem',
    spacing_negative_500: '-5.25rem',
    spacing_negative_600: '-7.5rem',
    spacing_negative_700: '-8rem',
    radius_comp_content_summarycard_radiussize: '1rem',
    color_comp_legal_riskindex_border: 'rgba(0, 0, 0, 1)',
    color_comp_legal_riskindex_font: 'rgba(0, 0, 0, 1)',
    color_comp_legal_risklevelbar_font: 'rgba(0, 0, 0, 1)',
    color_comp_legal_riskindex_number_font: 'rgba(89, 111, 115, 1)',
    color_chart_crypto_bg_opacity_btc: 'rgba(197, 111, 7, 0.24705882352941178)',
    color_chart_crypto_bg_opacity_eth: 'rgba(150, 99, 233, 0.24705882352941178)',
    color_chart_crypto_bg_opacity_dot: 'rgba(230, 0, 116, 1)',
    color_chart_crypto_bg_opacity_ltc: 'rgba(83, 127, 198, 0.24705882352941178)',
    color_chart_crypto_bg_opacity_avax: 'rgba(232, 65, 66, 0.24705882352941178)',
    color_chart_crypto_bg_opacity_matic: 'rgba(125, 26, 255, 0.24705882352941178)',
    color_chart_crypto_bg_opacity_ada: 'rgba(51, 112, 255, 0.24705882352941178)',
    color_chart_crypto_bg_opacity_algo: 'rgba(0, 0, 0, 0.24705882352941178)',
    color_chart_crypto_bg_opacity_atom: 'rgba(115, 121, 165, 0.24705882352941178)',
    radius_comp_commercial_banner_container_radiussize: '1.5rem',
    radius_comp_commercial_banner_image_radiussize: '1.25rem',
    color_comp_forms_fileuploader_bg: 'rgba(255, 255, 255, 1)',
    color_comp_forms_fileuploader_border: 'rgba(187, 202, 205, 1)',
    color_comp_forms_fileuploader_icon: 'rgba(5, 56, 64, 1)',
    radius_comp_forms_fileuploader_radiussize: '1rem',
    color_comp_forms_fileuploader_loadingcontainer_border: 'rgba(10, 111, 101, 1)',
    color_comp_forms_stackablecardselector_selected_bg: 'rgba(230, 255, 255, 1)',
    color_comp_legal_risklevelbar_number_active_font: 'rgba(255, 255, 255, 1)',
    radius_comp_content_basiccard_radiussize: '1rem',
    color_comp_containers_bubble_loader_bgcolor: 'rgba(36, 36, 36, 1)',
    color_comp_containers_draggablecontainer_unselected_bg: 'rgba(95, 121, 125, 1)',
    color_comp_containers_draggablecontainer_selected_bg: 'rgba(5, 56, 64, 1)',
    color_comp_legal_risklevelbar_container_active_bg: 'rgba(0, 0, 0, 1)',
    color_comp_forms_calendar_day_selected_bg: 'rgba(5, 56, 64, 1)',
    color_comp_actions_iconbutton_secondaryfilled_shadow: 'rgba(255, 255, 255, 0)',
    color_exception_neutral_border_onsurface_75: 'rgba(95, 121, 125, 1)',
    color_exception_neutral_bg_875: 'rgba(5, 56, 64, 1)',
    color_exception_neutral_border_150: 'rgba(5, 56, 64, 1)',
    color_exception_accent_selected_border_100: 'rgba(206, 112, 24, 1)',
    color_comp_forms_calendar_day_range_bg: 'rgba(5, 56, 64, 0.14901960784313725)',
    color_exception_accent_loading_secondary_bg_150: 'rgba(31, 127, 141, 1)',
    color_comp_status_progressbar_chart_filled_second_bg: 'rgba(204, 26, 26, 1)',
    color_comp_datavisualization_chartlegend_icon: 'rgba(5, 56, 64, 1)',
    color_comp_status_progressbar_linear_font: 'rgba(5, 56, 64, 1)',
    color_comp_status_tag_feedback_fontcolor: 'rgba(5, 56, 64, 1)',
    color_chart_bg_700: 'rgba(5, 56, 64, 1)',
    color_chart_bg_800: 'rgba(5, 56, 64, 1)',
    color_accent_default_primary_icon_200: 'rgba(255, 255, 255, 1)',
    color_accent_default_secondary_icon_150: 'rgba(5, 56, 64, 1)',
    color_exception_accent_default_secondary_icon_200: 'rgba(5, 56, 64, 1)',
    color_accent_default_secondary_font_100: 'rgba(5, 56, 64, 1)',
    color_exception_accent_default_secondary_font_200: 'rgba(5, 56, 64, 1)',
    color_exception_accent_default_secondary_bg_50: 'rgba(255, 255, 255, 0)',
    color_exception_accent_default_bg_50: 'rgba(36, 36, 36, 1)',
    color_exception_accent_default_bg_100: 'rgba(204, 26, 26, 1)',
    color_exception_accent_pressed_tertiary_border_50: 'rgba(5, 56, 64, 1)',
    color_exception_accent_pressed_tertiary_bg_50: 'rgba(255, 255, 255, 0)',
    color_accent_pressed_secondary_font_100: 'rgba(5, 56, 64, 1)',
    color_accent_pressed_secondary_icon_100: 'rgba(5, 56, 64, 1)',
    color_exception_accent_selected_border_50: 'rgba(255, 255, 255, 0)',
    color_accent_selected_bg_150: 'rgba(230, 255, 255, 1)',
    color_exception_accent_selected_bg_50: 'rgba(255, 255, 255, 1)',
    color_exception_accent_disabled_font_50: 'rgba(84, 102, 109, 1)',
    color_exception_accent_disabled_icon_50: 'rgba(84, 102, 109, 1)',
    color_exception_accent_disabled_bg_50: 'rgba(221, 229, 231, 1)',
    color_exception_accent_hover_secondary_font_150_onsurface_red: 'rgba(10, 89, 101, 1)',
    color_exception_accent_hover_secondary_icon_150_onsurface_red: 'rgba(10, 89, 101, 1)',
    color_exception_accent_hover_secondary_border_100_onsurface_red: 'rgba(10, 89, 101, 1)',
    color_exception_accent_hover_secondary_bg_100_onsurface: 'rgba(230, 255, 255, 1)',
    color_exception_accent_hover_bg_50: 'rgba(246, 250, 251, 1)',
    color_exception_accent_loading_secondary_border_50: 'rgba(5, 56, 64, 1)',
    color_neutral_bg_600: 'rgba(255, 255, 255, 1)',
    color_neutral_bg_550: 'rgba(246, 250, 251, 1)',
    color_neutral_bg_650: 'rgba(95, 121, 125, 1)',
    color_exception_neutral_bg_700: 'rgba(255, 255, 255, 1)',
    color_exception_neutral_bg_900: 'rgba(246, 250, 251, 1)',
    color_exception_neutral_bg_950: 'rgba(221, 229, 231, 1)',
    color_exception_neutral_bg_1000: 'rgba(246, 250, 251, 1)',
    color_exception_neutral_bg_1100: 'rgba(255, 234, 227, 1)',
    color_exception_neutral_bg_1200: 'rgba(221, 250, 252, 1)',
    color_exception_neutral_bg_1300: 'rgba(36, 36, 36, 1)',
    color_exception_neutral_bg_1400: 'rgba(246, 250, 251, 1)',
    color_exception_neutral_bg_825: 'rgba(221, 229, 231, 1)',
    color_exception_neutral_bg_850: 'rgba(255, 255, 255, 1)',
    color_neutral_bg_450: 'rgba(5, 56, 64, 1)',
    color_neutral_font_200: 'rgba(255, 255, 255, 1)',
    color_neutral_font_350: 'rgba(5, 56, 64, 1)',
    color_exception_neutral_font_400: 'rgba(5, 56, 64, 1)',
    color_exception_neutral_font_450: 'rgba(10, 89, 101, 1)',
    color_neutral_font_150: 'rgba(95, 121, 125, 1)',
    color_neutral_icon_300: 'rgba(5, 56, 64, 1)',
    color_neutral_icon_250: 'rgba(255, 255, 255, 1)',
    color_exception_neutral_icon_350: 'rgba(255, 255, 255, 1)',
    color_exception_neutral_icon_500: 'rgba(36, 36, 36, 1)',
    color_exception_neutral_icon_550: 'rgba(122, 237, 224, 1)',
    color_exception_neutral_icon_600: 'rgba(122, 237, 224, 1)',
    color_neutral_border_50: 'rgba(5, 56, 64, 1)',
    color_neutral_border_250: 'rgba(255, 255, 255, 0)',
    color_neutral_border_350: 'rgba(145, 170, 173, 1)',
    color_exception_neutral_border_onsurface_50: 'rgba(145, 170, 173, 1)',
    color_exception_secondary_bg_100: 'rgba(5, 56, 64, 1)',
    color_exception_secondary_bg_150: 'rgba(6, 113, 128, 1)',
    color_exception_secondary_icon_50: 'rgba(5, 56, 64, 1)',
    color_exception_feedback_error_bg_350: 'rgba(255, 234, 227, 1)',
    color_exception_feedback_success_bg_200: 'rgba(236, 255, 240, 1)',
    color_exception_brand_bg_50: 'rgba(206, 112, 24, 1)',
    color_exception_brand_icon_100: 'rgba(5, 56, 64, 1)',
    color_neutral_font_onsurface_100: 'rgba(255, 255, 255, 1)',
    color_neutral_icon_onsurface_100: 'rgba(255, 255, 255, 1)',
    border_200: '0.125rem',
    color_comp_legal_riskindex_icon: 'rgba(0, 0, 0, 1)',
    color_comp_status_tag_identification_bg: 'rgba(242, 161, 84, 1)',
    color_comp_status_tag_identification_icon: 'rgba(36, 36, 36, 1)',
    color_comp_status_tag_identification_font: 'rgba(36, 36, 36, 1)',
    color_comp_status_tag_inprocess_bg: 'rgba(237, 227, 74, 1)',
    color_comp_status_tag_inprocess_icon: 'rgba(5, 56, 64, 1)',
    color_comp_status_tag_inprocess_font: 'rgba(5, 56, 64, 1)',
    color_comp_status_tag_critical_bg: 'rgba(159, 0, 0, 1)',
    color_comp_status_tag_critical_icon: 'rgba(255, 255, 255, 1)',
    color_comp_status_tag_critical_font: 'rgba(255, 255, 255, 1)',
    color_comp_status_tag_preaproved_bg: 'rgba(177, 81, 102, 1)',
    color_comp_status_tag_preaproved_icon: 'rgba(255, 255, 255, 1)',
    color_comp_status_tag_preaproved_font: 'rgba(255, 255, 255, 1)',
};
//# sourceMappingURL=bnplLightRegular.js.map